/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';  
import { useTranslation } from 'react-i18next';   
import FieldButton from '../../../components/Controls/FieldButton/FieldButton.jsx';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Row, Col, Card, CardBody } from 'reactstrap';
import FieldNumber from '../../../components/Controls/FieldNumber.jsx'
import FieldText from '../../../components/Controls/FieldText.jsx' 
import FieldDataTable from '../../../components/Controls/FieldDataTable/FieldDataTable.jsx';

const PerformanceDevQuestionario = ({
  questionario,
  onChange,
  errors,
  name
}) => { 
   
  /* ################## useState area start ################## */
  const { t } = useTranslation(['hr', 'common']); 
  // const [PerformanceDevQuestionario, setPerformanceDevQuestionario] = useState(questionario);  

  const descPreguntaEditor = (props, rowData) => {
    return (
      <div className="p-fluid">
        <FieldText   
          name="DescripcionPregunta"
          value={props.rowData.DescripcionPregunta} 
          onChange={(e) => onDescPreguntaValueChange(props, e.target.value, rowData)}
          errors={errors[`${name}[${props.rowData.RowIndex}]`]}
        />  
      </div>
      
    );
 }

 const onDescPreguntaValueChange = (props, value ) => {  
  const updatedProducts = [...questionario];
  updatedProducts[props.rowData.RowIndex][props.field] = value;
  onQuestionarioChange(updatedProducts); 
}; 

const onQuestionarioChange = (questionario) => {
    // setPerformanceDevQuestionario(questionario); 
    onChange(questionario)
}

const orderByEditor = (props, rowData) => {
  return (
    <div className="p-fluid">
      <FieldNumber  
        value={props.rowData.Orden} 
        onChange={(e) => onorderByChange(props, e.target.value, rowData)}
      />  
    </div>
    
  );
}

const onorderByChange = (props, value ) => {  
  const updatedProducts = [...questionario];
  updatedProducts[props.rowData.RowIndex][props.field] = value;
  onQuestionarioChange(updatedProducts); 
}; 
  
const addNewRow = () => {  
 
  const newRow = { 
    RowIndex: questionario.length,
    IdPerformanceDevQuestionario: null,
    IdPerformanceDev: null,
    BajaLogica: 0,
    DescripcionPregunta: "",
    Orden: null
  };   
 
  onQuestionarioChange([...questionario, newRow]);
} 

const handleRemoveClick = (rowData) => {
  const currentList = [...questionario];
  currentList[rowData.RowIndex].BajaLogica = 1;
  onQuestionarioChange(currentList); 
};


const showActiveRows = (rows) => {

  const activeRows = [];

  if (rows.length>0) {
    rows.forEach((item, index) => {
      if (item.BajaLogica === 0) {
        item.RowIndex = index;
        activeRows.push({...item});
      }
    });
  } else {
    return [];
  }
 
  return activeRows; 
};

const actionBodyTemplate = (rowData) => {
  return (
    <> 
      <FieldButton icon="pi pi-trash" onClick={() => handleRemoveClick(rowData)} className="p-button-rounded p-button-warning" /> 
    </>
  );
}

const emptyValueValidator = (e) => {
  const { rowData, field } = e.columnProps;
  return rowData[field].trim().length > 0;
}

const fieldsRequired = (rowData) =>  { 
  return (
    <>
      {errors[`${name}[${rowData.RowIndex}]`] != null ? (<i className="fas fa-exclamation-triangle invalid-color"></i>) : ""}
    </>
  );
} 
  return (
    <> 
      <Row>
        <Col lg={12} md={12} sm={12} xs={12}>
          <FieldButton label={t('common:New')} icon="pi pi-plus" className="p-button-success p-mr-2" onClick={addNewRow} />  
        </Col>
      </Row>
      <Row>
        <Col lg={12} md={12} sm={12} xs={12}> 
            &nbsp;
        </Col> 
      </Row>
      <Row>
        <Col lg={12} md={12} sm={12} xs={12}> 
          <FieldDataTable value={showActiveRows(questionario)} editMode="cell" className="editable-cells-table"> 
            <Column body={fieldsRequired} headerStyle={{ width: '20px' }}></Column>
            <Column field="DescripcionPregunta" header={t('hr:QuestionDesc')} headerStyle={{ width: '70%' }} editorValidator={emptyValueValidator} editor={(props) => descPreguntaEditor(props)}></Column>
            <Column field="Orden" header={t('hr:OrderBy')} headerStyle={{ width: '30%' }} editor={(props) => orderByEditor(props)}></Column>  
            <Column body={actionBodyTemplate} headerStyle={{ width: '70px' }}></Column>
          </FieldDataTable> 
        </Col>  
      </Row>
    </>
  );
}; 

export default PerformanceDevQuestionario;


